import { all, call, put, takeLatest } from "redux-saga/effects";
import { getBirthdaysInMonthAPI } from "core/http/service/birthday";
import {
  getBirthdaysInMonthDataSuccess,
  getBirthdaysInMonthDataFailed,
  getBirthdaysInMonthDataStart,
} from "../redux/getBirthdaysInMonth";

function* getBirthdaysInMonthDataWork(action) {
  try {
    const payload = action.payload;
    const res = yield call(getBirthdaysInMonthAPI, payload);

    yield put({ type: getBirthdaysInMonthDataSuccess.type, payload: res });
  } catch (error: any) {
    yield put({ type: getBirthdaysInMonthDataFailed.type });
  }
}

function* watchGetBirthdayData() {
  yield takeLatest(
    getBirthdaysInMonthDataStart.type,
    getBirthdaysInMonthDataWork
  );
}

export default function* getBirthdayDataSaga() {
  yield all([watchGetBirthdayData()]);
}
